import {
  DeleteExtraHourRangeDocument,
  DeleteExtraHourRangeMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteExtraRuleRange = () => {
  const [deleteExtraHourRange, { loading }] = useMutation(DeleteExtraHourRangeDocument, {
    extractorFn: (data) => data.attendanceMutations.deleteAttendanceExtraHoursRange,
  })

  const deleteHourRange = (variables: DeleteExtraHourRangeMutationVariables) => {
    return deleteExtraHourRange({
      variables,
      update(cache) {
        cache.evict({
          id: cache.identify({ id: variables.id, __typename: 'AttendanceExtraHoursRange' }),
        })
        cache.gc()
      },
    })
  }

  return {
    loading,
    deleteHourRange,
  }
}
